let hasRendered = false;

export default function renderRecaptcha(sitekey: string, container?: HTMLElement) {
	if (hasRendered) {
		return;
	}

	hasRendered = true;

	if (!container) {
		const div = document.createElement('div');
		div.id = 'grecaptcha';
		document.body.appendChild(div);

		container = div;
	}

	grecaptcha.render(container, {
		callback: (response) => {
			return (window as any).recaptchaSuccessCallback(response);
		},
		'error-callback': () => {
			return (window as any).recaptchaErrorCallback();
		},
		sitekey,
		size: 'invisible'
	});
}
